import Tag from '../Tag';

/**
 * ConsentManager.Tag.DefaultTag
 *
 * @author Felix Kiesewetter <info@felixkiesewetter.de>
 * @lastModified 2024-11-28
 * @package felixkiesewetter-js/consentmanager
 * @since 5.0.0
 */
class DefaultTag extends Tag
{

    // Protected
    _name = 'default';
    _readonly = true;
    _required = true;

    /**
     * DefaultTag constructor
     *
     * @param {Object} options
     */
    constructor(options)
    {
        super(options);
    }

}

export default DefaultTag;
